/**
 * @Relay no-runtime
 */
/**
 * @graphql cc
 */

import graphql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import { getDaysFromNowIncludingFractionalDays } from '../utils/date';

import type { useGetTenantDataFromCGraphQLQuery } from './__types__/useGetTenantDataFromCGraphQLQuery';

interface UseGetTenantDataFromCGraphQLProps {
	skip?: boolean;
}

export function useGetTenantDataFromCGraphQL({ skip = false }: UseGetTenantDataFromCGraphQLProps) {
	const { data, loading, error } = useQuery<useGetTenantDataFromCGraphQLQuery>(
		graphql`
			query useGetTenantDataFromCGraphQLQuery {
				license {
					billingSourceSystem
					trialEndDate
					firstPredunningEndTime
				}
			}
		`,
		{
			skip,
			fetchPolicy: 'cache-and-network',
		},
	);

	const billingSourceSystem = data?.license?.billingSourceSystem;

	const daysUntilPredunningEnd =
		getDaysFromNowIncludingFractionalDays(data?.license?.firstPredunningEndTime) ?? 0;
	const daysLeftInTrial = getDaysFromNowIncludingFractionalDays(data?.license?.trialEndDate) ?? 0;

	const isInTrialOrPreDunning = daysUntilPredunningEnd > 0 || daysLeftInTrial > 0;

	return {
		billingSourceSystem,
		isInTrialOrPreDunning,
		predunningEndTime: data?.license?.firstPredunningEndTime,
		trialEndDate: data?.license?.trialEndDate,
		daysLeftInTrial,
		loading,
		error,
	};
}
